class ProfetGutenberg {
	constructor() {}
	init() {
		/* Add a .profet class to the .editor-styles-wrapper element so that everything is styled correctly */
		if (!document.querySelector('body').classList.contains('wp-admin')) {
			return;
		}
		//this.addClassesToWrapper();
	}
	addClassesToWrapper() {
		let wrappers = document.querySelectorAll('.editor-styles-wrapper');
		if (wrappers) {
			wrappers.forEach((wrapper) => {
				wrapper.classList.add('profet');
				wrapper.classList.remove('editor-styles-wrapper'); // Remove the class to fix the issues with overriding styles
			});
		}
	}
}
window.addEventListener('load', () => {
	window.ProfetGutenberg = new ProfetGutenberg();
	window.ProfetGutenberg.init();
});
